import React from 'react';
import ReactDOM from 'react-dom/client'; // if using React 18 or above
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css'; // optional if you have global CSS

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
